import { Market, SportMatchModel } from '@nf/types/odds';
import {
	BetTypeCol2,
	BetTypeCol3,
	BetTypeCol32to1,
	BetTypeCol3GoalFromOdds,
	BetTypeCol3GoalFromOptions,
	BetTypeCol4,
	BetTypeCricketFancy,
	BetTypeScoreBox,
	BetTypeHalfTimeFullTimeLinked,
	BetTypePenalty,
	BetTypeCol2FastMarket,
	BetTypePointCorrectScore,
	BetTypeEndingGame,
	BetTypeRowTitleCol3,
	BetTypeCol2ChoiceOptions,
	BetTypeCol2GoalFromOptions,
	BetTypeCol2GoalFromOdds
} from '../bet-type-layouts';
import { useGetBetTypeSetting } from '@/hooks';

export interface BetTypeContentProps {
	matchModel: SportMatchModel;
	betTypeArray: Market[];
	childMatchTeamNameMap?: Map<number, string>;
}

export const BetTypeContent = (betTypeContentProps: BetTypeContentProps) => {
	const { matchModel, betTypeArray } = betTypeContentProps;
	const market = betTypeArray[0];
	const getBetTypeSetting = useGetBetTypeSetting()
	const { layoutType } = getBetTypeSetting(market.BetTypeId, matchModel.GameID)
	if (layoutType === undefined) {
		return <>{betTypeArray[0].BetTypeId} - {matchModel.MatchId}</>;
	}
	
	return (
		<>
			{
				{
					'Col-2': <BetTypeCol2 {...betTypeContentProps} />,
					'Col-2-Goal-Odds': <BetTypeCol2GoalFromOdds {...betTypeContentProps} />,
					'Col-2-Goal-Options': <BetTypeCol2GoalFromOptions {...betTypeContentProps} />,
					'Col-2-Choice-Options': <BetTypeCol2ChoiceOptions {...betTypeContentProps} />,
					'Col-3': <BetTypeCol3 {...betTypeContentProps} />,
					'Col-3-Goal-Odds': <BetTypeCol3GoalFromOdds {...betTypeContentProps} />,
					'Col-3-Goal-Options': <BetTypeCol3GoalFromOptions {...betTypeContentProps} />,
					'Col-3-2to1': <BetTypeCol32to1 {...betTypeContentProps} />,
					'Col-4': <BetTypeCol4 {...betTypeContentProps} />,
					'Cricket-Fancy': <BetTypeCricketFancy {...betTypeContentProps} />,
					'Score-Box': <BetTypeScoreBox {...betTypeContentProps} />,
					'Penalty': <BetTypePenalty {...betTypeContentProps} />,
					'HT-FT-Linked': <BetTypeHalfTimeFullTimeLinked {...betTypeContentProps} />,
					'Col-2-Fast-Market': <BetTypeCol2FastMarket {...betTypeContentProps} />,
					'Point-Correct-Score': <BetTypePointCorrectScore {...betTypeContentProps} />,
					'EndingGame': <BetTypeEndingGame {...betTypeContentProps} />,
					'Row-Title-Col-3': <BetTypeRowTitleCol3 {...betTypeContentProps} />
				}[layoutType]
			}
		</>
	)
};
